import { connect } from 'react-redux';
import _isEmpty from 'lodash/isEmpty';
import dayjs from 'dayjs';
import { ToastAction } from '@zola-helpers/client/dist/es/redux/toasts/toastActionTypes';

import { createOrUpdateGuestCollection } from 'actions/GuestCollectionActions';
import { getGuestCollection, getGuestCollectionTempImg } from 'selectors/guestCollection';
import { getCachedUploadcareFiles } from 'selectors/uploadcareSelectors';
import { getUserWeddingDate } from 'selectors/user/userSelectors';
import {
  mapGuestCollectionToFormValues,
  mapFormValuesToGuestCollection,
} from 'components/manage/guestlist/addressCollection/helpers/mapper';

import ConfigureAddressCollectionFormValues from 'components/manage/guestlist/addressCollection/@types/formValues';
import type { GuestCollectionActionTypes } from 'actions/types/GuestCollectionActionTypes';
import type { AppDispatch, RootState } from '../../../../../reducers';
import type { GuestCollectionReducerStateType } from '../../../../../reducers/guestCollection';

import ConfigureAddressCollectionLinkForm from './ConfigureAddressCollectionLinkForm';

export type ConfigureAddressCollectionLinkFormStateProps = {
  initialValues: ConfigureAddressCollectionFormValues;
  tempImg: GuestCollectionReducerStateType['tempImg'];
  savedImg?: string;
  savedImgUuid?: string;
  isUploadCareBusy: boolean;
  ucWeddingDate?: string;
};

const mapStateToProps = (state: RootState): ConfigureAddressCollectionLinkFormStateProps => {
  const guestCollection = getGuestCollection(state);
  const ucWeddingDate = getUserWeddingDate(state);
  return {
    ucWeddingDate,
    initialValues: {
      ...mapGuestCollectionToFormValues(guestCollection),
      weddingDate: dayjs(ucWeddingDate).format('MM/DD/YYYY'),
    },
    savedImg: guestCollection.image_link,
    savedImgUuid: guestCollection.image_uuid,
    tempImg: getGuestCollectionTempImg(state),
    isUploadCareBusy: !_isEmpty(getCachedUploadcareFiles(state)),
  };
};

export type ConfigureAddressCollectionLinkFormDispatchProps = {
  onCreateOrUpdateAddressCollection: (
    values: ConfigureAddressCollectionFormValues
  ) => Promise<GuestCollectionActionTypes | ToastAction>;
};

const mapDispatchToProps = (
  dispatch: AppDispatch
): ConfigureAddressCollectionLinkFormDispatchProps => ({
  onCreateOrUpdateAddressCollection: (
    values: ConfigureAddressCollectionFormValues
  ): Promise<GuestCollectionActionTypes | ToastAction> =>
    dispatch(createOrUpdateGuestCollection(mapFormValuesToGuestCollection(values))),
});

export default connect(mapStateToProps, mapDispatchToProps)(ConfigureAddressCollectionLinkForm);



// WEBPACK FOOTER //
// ./src/components/manage/guestlist/addressCollection/ConfigureAddressCollectionLinkForm/index.ts